import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import CircleKeyIcon from 'zignal-landscape/lib/Icon/CircleKeyIcon';

const FilterButton = ({
  styles,
  color,
  term,
  count,
  filtered,
  onClick
}) => {
  const localeCount = count.toLocaleString();
  return (
    <div onClick={onClick} style={filtered ? {} : {color}} className={styles.FilterButton}>
      <span className={styles.icon}>
        <span style={filtered ? {} : {color}}><CircleKeyIcon /></span>
      </span>
      <span className={styles.term}>
        {term}
      </span>
      <span className={styles.count}>
        {localeCount}
      </span>
    </div>
  );
};

FilterButton.propTypes = {
  styles: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  term: PropTypes.string.isRequired,
  color: PropTypes.string,
  filtered: PropTypes.bool
};

export default themeable(FilterButton);
